/**
 * Enum for the native Ad placement in Outlook web
 * None -- Native Ad will not show
 * OtherOnly -- It only shows in the Other pivot when Focus/Other inbox is enabled. It will not show in Inbox whether or not Focus/Other inbox is turned on or off
 * OtherPrefer -- It shows in the Other pivot but not Focus when Focus/Other inbox is enabled. It will show in Inbox when Focus/Other inbox is turned off
 * AllInbox -- It will show in Inbox regardless of the Focus/Other inbox settings
 */
const enum NativeAdPlacement {
    None,
    OtherOnly,
    OtherPrefer,
    AllInbox,
}

export default NativeAdPlacement;
